import { styles } from './styles'

export default function SuggestedTags({ children }) {
  return (
    <div className="grui flex items-center p-4 mr-4" css={styles.wrapper}>
      {children}
    </div>
  )
}
